import { apiClient } from "@nabble/sdk";

export interface Permission {
  key: string;
  moduleId: string | null;
  description: string;
  /** ORGANIZATION: inside one organization; INSTALLATION: over the whole suite. */
  scope: "ORGANIZATION" | "INSTALLATION";
}

export function fetchPermissions(): Promise<Permission[]> {
  return apiClient<Permission[]>("/api/admin/permissions");
}
